import { M3Ubicacion } from "../Maestro/Ubicacion/M3Ubicacion.type";
import { M3UbiAdicionales } from "projects/reglanegociom31/src/public_api";

export class M3UbicacionService {

    private goM3Ubicacion: M3Ubicacion;
    constructor(oM3Ubicacion: M3Ubicacion) {
        this.goM3Ubicacion = oM3Ubicacion;
    }

    public GetDireccion() {
        return this.GetAdicionarByAtribute("DIRECCION");
    }

    public GetTelefono() {
        return this.GetAdicionarByAtribute("TELEFONO");
    }

    public GetLong() {
        return this.GetAdicionarByAtribute("LONG");
    }

    public GetLat() {
        return this.GetAdicionarByAtribute("LAT");
    }


    private GetAdicionarByAtribute(Atributo: string) {
        try {
            var oAdicional: M3UbiAdicionales = this.goM3Ubicacion.M3UbiAdicionales.find(adi => adi.Atributo == Atributo);
            if (oAdicional !== undefined && oAdicional != null) {
                return oAdicional.Valor;
            }
            return "N/A";
        }catch{
            return "N/A";
        }
        
    }

}